import type React from 'react';

import { Scroller } from '../session-scroller';
import * as st from './styles.module.scss';

type Props = {
	sessions: any[];
	onClick: (id: number) => void;
};

export const OnlineSessions: React.FC<Props> = ({ sessions, onClick }) => {
	return (
		<>
			{sessions.length > 0 ? (
				<Scroller sessions={sessions} onClick={onClick} quantity={42} />
			) : (
				<div className={st.message}>Нет свободного времени</div>
			)}
		</>
	);
};
